import {
	COLOR_BASE_CHARGING_NEON_GREEN_LIGHT,
	COLOR_BASE_GREY_0,
	COLOR_BASE_GREY_50,
} from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';

export const IncentiveStyle = styled.div<{ alternateDesign?: boolean }>`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: ${({ alternateDesign }) => (alternateDesign ? 0 : '16px')};
	position: relative;

	.header {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin-bottom: 12px;
		gap: 12px;

		.selectable {
			cursor: pointer;
			display: flex;
			align-items: flex-start;
			margin-right: auto;
			gap: 12px;
			div,
			label {
				cursor: pointer;
			}
		}

		.check-container {
			position: relative;
			user-select: none;
			width: 24px;
			height: 24px;
			border-radius: 100%;
			flex-grow: 0;
			flex-shrink: 0;
		}

		.check-input {
			position: absolute;
			width: 0;
			height: 0;
			left: 0;
			top: 0;
			opacity: 0;
		}

		.check-checkmark {
			position: absolute;
			top: 0;
			left: 0;
			width: 24px;
			height: 24px;
			background-color: ${COLOR_BASE_GREY_0};
			border: 1px solid ${COLOR_BASE_GREY_50};
			border-radius: 100%;
			pointer-events: none;

			&::after {
				content: '';
				position: absolute;
				width: 24px;
				height: 24px;
				left: -1px;
				top: -1px;
				border-radius: 100%;
			}
		}

		.check-input:checked ~ .check-checkmark:after {
			background-color: ${COLOR_BASE_CHARGING_NEON_GREEN_LIGHT};
			background-image: url('data:image/svg+xml;utf8,<?xml version="1.0" ?><svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M5.33334 12.7143L9.56341 17L18.6667 7" stroke="%23fff" stroke-linecap="round" stroke-width="2"/></svg>');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
		}

		.title {
			margin-left: 12px;
			margin-right: 8px;
			user-select: none;
		}

		.price-container {
			display: flex;
			flex-direction: column;
			align-items: end;
		}

		.lowest-price-container {
			display: flex;
			align-items: center;
		}
	}

	.footer {
		display: flex;
		align-items: center;
		margin-top: 16px;
	}
`;

export const IncentiveLoadingStyles = styled.div`
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;
